import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeInitializerService } from './utils/theme-initializer.service';
import { loginSuccess } from './auth/store/auth.action';
import { Store } from '@ngrx/store';
import { AuthService } from './auth/auth.service';
import { ToasterComponent } from "./providers/toaster/toaster.component";


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToasterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'teacherFactor-FrontendAngular';

  constructor(private themeInitalize:ThemeInitializerService, private store:Store, private authService:AuthService){
    
  
  }
  ngOnInit():void{
    this.authService.loadAuthDataFromLocalStorage();
    this.themeInitalize.initializeTheme();
  }



}
